module.exports = "/_next/static/images/teacher-8-7100f36b2fb4b30f2f4ac81a6e26a959.png";